var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { t } from "../I18N";

const SearchTipsContent = () => /*#__PURE__*/
_jsx("ul", {}, void 0, /*#__PURE__*/
_jsx("li", {}, void 0,
t(
  'System',
  'Search Tips: wildcard',
  'Use an * for wildcard search. Ie: "juris*" will match words  ' +
  'such as jurisdiction, jurisdictional, jurists, jurisprudence, etc.',
  false
)
), /*#__PURE__*/
_jsx("li", {}, void 0,
t(
  'System',
  'Search Tips: one char wildcard',
  '? for one character wildcard. Ie: "198?" will match 1980 to 1989 and also 198a, 198b, etc.',
  false
)
), /*#__PURE__*/
_jsx("li", {}, void 0,
t(
  'System',
  'Search Tips: exact term',
  'Exact term match by enclosing your search string with quotes. Ie. "Costa Rica"' +
  ' will toss different results compared to Costa Rica without quotes.',
  false
)
), /*#__PURE__*/
_jsx("li", {}, void 0,
t(
  'System',
  'Search Tips: proximity',
  '~ for proximity searches. Ie: "the status"~5 will find anything having "the" and' +
  '"status" within a distance of 5 words, such as "the procedural status", "the specific legal status".',
  false
)
), /*#__PURE__*/
_jsx("li", {}, void 0,
t(
  'System',
  'Search Tips: boolean',
  'AND, OR and NOT for boolean searches. Ie. "status AND women NOT Nicaragua" will match anything ' +
  'containing both the words status and women, and necessarily not containing the word Nicaragua.',
  false
)
)
);


export { SearchTipsContent };